import { render, staticRenderFns } from "./DirectSchoolTitle.vue?vue&type=template&id=2b38d60f&scoped=true&"
import script from "./DirectSchoolTitle.vue?vue&type=script&lang=js&"
export * from "./DirectSchoolTitle.vue?vue&type=script&lang=js&"
import style0 from "./DirectSchoolTitle.vue?vue&type=style&index=0&id=2b38d60f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38d60f",
  null
  
)

export default component.exports